import { render, staticRenderFns } from "./appLangChooser.vue?vue&type=template&id=0999c598&scoped=true&"
import script from "./appLangChooser.vue?vue&type=script&lang=js&"
export * from "./appLangChooser.vue?vue&type=script&lang=js&"
import style0 from "./appLangChooser.vue?vue&type=style&index=0&id=0999c598&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0999c598",
  null
  
)

export default component.exports